export default theme => ({
  root: {
    '&, & *': {
      boxSizing: 'border-box'
    },
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  canvas: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    width: '100%',
    maxWidth: 455,
    padding: 32
  },
  logo: {
    marginBottom: 60
  },
  title: {
    textAlign: 'center'
  },
  description: {
    textAlign: 'center',
    marginTop: 28
  },
  image: {
    marginTop: 60
  }
});